import { auth } from "@app/config/firebase";
import { DefaultChatTransport } from "ai";

export function scriptToolUrl(path: string) {
  const base = (process.env.REACT_APP_API_URL || "").replace(/\/$/, "");
  return `${base}/ai-tools/creator-script-generator/${path}`;
}

export function createScriptTransport(url: string, body: () => Record<string, unknown>) {
  return new DefaultChatTransport({
    api: url,
    credentials: "include",
    headers: async () => {
      const token = (await auth.currentUser?.getIdToken()) || "";
      return { Authorization: `Bearer ${token}` };
    },
    body,
  });
}
